import { Select } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

type StatusFilterSelectProps<T extends string> = {
    value?: T;
    placeholderId: string;
    options: T[];
    getLabelId: (value: T) => string;
    onChange: (value?: T) => void;
    allowClear?: boolean;
    width?: number;
};

const StatusFilterSelect = <T extends string>({
    value,
    placeholderId,
    options,
    getLabelId,
    onChange,
    allowClear = true,
    width = 220,
}: StatusFilterSelectProps<T>) => {
    const { formatMessage } = useIntl();

    return (
        <Select
            allowClear={allowClear}
            placeholder={<FormattedMessage id={placeholderId} />}
            style={{ width }}
            value={value}
            onChange={(next) => onChange(next)}
            options={options.map((status) => ({
                value: status,
                label: formatMessage({ id: getLabelId(status) }),
            }))}
        />
    );
};

export default StatusFilterSelect;
